const prefix = 'capabilities';

const _helper = (reqCaps, suffix = null) => {
  const preparedSuffix = suffix ? `/${suffix}` : '';

  const capabilityActions = [];
  for (var k in reqCaps) {
    const value = `${prefix}/${reqCaps[k].KEY}${preparedSuffix}`;
    capabilityActions.push(value);
  }

  return capabilityActions;
};

export const getLoadingActions = reqCaps => _helper(reqCaps, 'loading');
export const getFinalizedActions = reqCaps => _helper(reqCaps);

export const hasCapsAccess = (reqCaps, props = {}) => {
  return (
    typeof reqCaps === 'object' &&
    Object.keys(reqCaps).reduce((accVal, cap) => accVal && !!props[cap], true)
  );
};
